import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["src", "onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_picture_beforeafter = _resolveComponent("picture_beforeafter");
  return _openBlock(), _createElementBlock("div", {
    class: "space",
    id: "compare_section",
    onSlideStart: _cache[1] || (_cache[1] = (...args) => $options.handlePictureSlideStart && $options.handlePictureSlideStart(...args)),
    onSlideEnd: _cache[2] || (_cache[2] = (...args) => $options.handlePictureSlideEnd && $options.handlePictureSlideEnd(...args))
  }, [_createElementVNode("div", null, [_createVNode(_component_picture_beforeafter, {
    before: $data.imagelist_narrow[$data.highlightedIndex].img_0,
    after: $data.imagelist_narrow[$data.highlightedIndex].img_1
  }, null, 8, ["before", "after"])]), _createElementVNode("div", {
    class: "image-container",
    ref: "imageContainer",
    onScroll: _cache[0] || (_cache[0] = (...args) => $options.handleScroll && $options.handleScroll(...args))
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.imagelist_narrow, (image, index) => {
    return _openBlock(), _createElementBlock("img", {
      src: image.img_0,
      alt: "",
      class: _normalizeClass(["image-item", {
        'highlighted': index === $data.highlightedIndex
      }]),
      onClick: $event => $options.handleClick(image, index)
    }, null, 10, _hoisted_1);
  }), 256))], 544)], 32);
}